// Prebuilt ID Card templates (no-code presets)
// Coordinates are percentages of card width/height for responsive rendering

export const ID_CARD_PRESETS = [
  {
    id: 'aurora-wave',
    name: 'Aurora Wave',
    metadata: { description: 'Colorful gradient wave with bold identity' },
    size: 'CR80',
    orientation: 'landscape',
    background: { color: '#0B1026', accentColor: '#7C4DFF', imageUrl: '' },
    elements: [
      { id: 'wave1', type: 'shape', x: -10, y: 70, w: 120, h: 60, color: '#7C4DFF', opacity: 0.9, rotate: -8, shapeType: 'rounded', radius: 24 },
      { id: 'wave2', type: 'shape', x: -8, y: 78, w: 116, h: 52, color: '#FF6E40', opacity: 0.8, rotate: -10, shapeType: 'rounded', radius: 28 },
      { id: 'logo', type: 'logo', x: 5, y: 6, w: 14, h: 14, src: '{school.logoUrl}' },
      { id: 'photo', type: 'photo', x: 78, y: 18, w: 18, h: 64, radius: 6, imgBinding: 'student', src: '{student.photoUrl}' },
      { id: 'schoolName', type: 'text', text: '{school.name}', x: 22, y: 10, w: 52, h: 10, fontSize: 6.5, fontWeight: 800, color: '#FFFFFF' },
      { id: 'name', type: 'text', text: '{name}', x: 22, y: 24, w: 52, h: 12, fontSize: 8.5, fontWeight: 800, color: '#FFFFFF' },
      { id: 'role', type: 'text', text: '{role}', x: 22, y: 36, w: 52, h: 8, fontSize: 5.5, color: '#CFD8DC' },
      { id: 'id', type: 'text', text: 'ID: {studentNumber}', x: 22, y: 46, w: 52, h: 8, fontSize: 5, color: '#ECEFF1' },
      { id: 'class', type: 'text', text: 'Class: {className}', x: 22, y: 54, w: 52, h: 8, fontSize: 5, color: '#ECEFF1' },
      { id: 'contact', type: 'text', text: '{guardian.name}  |  {guardian.phone}', x: 22, y: 62, w: 52, h: 8, fontSize: 4.5, color: '#CFD8DC' },
      { id: 'expiry', type: 'text', text: 'Expires {expiryDate}', x: 22, y: 70, w: 52, h: 8, fontSize: 4.5, color: '#CFD8DC' },
      { id: 'qr', type: 'qr', x: 6, y: 72, w: 12, h: 20, data: '{qr.loginUrl}' }
    ]
  },
  {
    id: 'sunrise-edge',
    name: 'Sunrise Edge',
    metadata: { description: 'Diagonal color blocks with modern contrast' },
    size: 'CR80',
    orientation: 'landscape',
    background: { color: '#FFFFFF', accentColor: '#FF7043', imageUrl: '' },
    elements: [
      { id: 'blockLeft', type: 'shape', x: 0, y: 0, w: 32, h: 100, color: '#FF7043' },
      { id: 'blockTop', type: 'shape', x: 28, y: 0, w: 72, h: 16, color: '#263238' },
      { id: 'blockDiag', type: 'shape', x: 32, y: 64, w: 68, h: 50, color: '#FFE082', rotate: -12, shapeType: 'rounded', radius: 16 },
      { id: 'logo', type: 'logo', x: 6, y: 8, w: 20, h: 16, src: '{school.logoUrl}' },
      { id: 'photo', type: 'photo', x: 6, y: 28, w: 20, h: 44, radius: 6, imgBinding: 'student', src: '{student.photoUrl}' },
      { id: 'name', type: 'text', text: '{name}', x: 36, y: 20, w: 58, h: 10, fontSize: 8, fontWeight: 800, color: '#263238' },
      { id: 'role', type: 'text', text: '{role}', x: 36, y: 30, w: 58, h: 8, fontSize: 5.5, color: '#455A64' },
      { id: 'class', type: 'text', text: 'Class: {className}', x: 36, y: 40, w: 58, h: 8, fontSize: 5, color: '#546E7A' },
      { id: 'id', type: 'text', text: 'ID: {studentNumber}', x: 36, y: 48, w: 58, h: 8, fontSize: 5, color: '#546E7A' },
      { id: 'contact', type: 'text', text: '{guardian.phone}', x: 36, y: 56, w: 58, h: 8, fontSize: 5, color: '#546E7A' },
      { id: 'barcode', type: 'barcode', x: 36, y: 70, w: 56, h: 18, data: '{studentNumber}' }
    ]
  },
  {
    id: 'emerald-ring',
    name: 'Emerald Ring',
    metadata: { description: 'Circular motif with premium green theme' },
    size: 'CR80',
    orientation: 'landscape',
    background: { color: '#F3F7F5', accentColor: '#00A67E', imageUrl: '' },
    elements: [
      { id: 'ring1', type: 'shape', x: 74, y: -12, w: 44, h: 44, color: '#00A67E', opacity: 0.15, shapeType: 'circle', lockAspect: true },
      { id: 'ring2', type: 'shape', x: 84, y: -6, w: 30, h: 30, color: '#00A67E', opacity: 0.2, shapeType: 'circle', lockAspect: true },
      { id: 'logo', type: 'logo', x: 5, y: 8, w: 14, h: 14, src: '{school.logoUrl}' },
      { id: 'schoolName', type: 'text', text: '{school.name}', x: 22, y: 10, w: 56, h: 8, fontSize: 6, fontWeight: 800, color: '#083C31' },
      { id: 'name', type: 'text', text: '{name}', x: 22, y: 24, w: 56, h: 10, fontSize: 8, fontWeight: 800, color: '#083C31' },
      { id: 'role', type: 'text', text: '{role}', x: 22, y: 34, w: 56, h: 8, fontSize: 5.5, color: '#2C6E5B' },
      { id: 'id', type: 'text', text: 'ID: {studentNumber}', x: 22, y: 44, w: 56, h: 8, fontSize: 5, color: '#2C6E5B' },
      { id: 'class', type: 'text', text: 'Class: {className}', x: 22, y: 52, w: 56, h: 8, fontSize: 5, color: '#2C6E5B' },
      { id: 'contact', type: 'text', text: '{guardian.name}', x: 22, y: 60, w: 56, h: 8, fontSize: 4.5, color: '#2C6E5B' },
      { id: 'photo', type: 'photo', x: 76, y: 22, w: 20, h: 56, radius: 8, imgBinding: 'student', src: '{student.photoUrl}' },
      { id: 'qr', type: 'qr', x: 6, y: 72, w: 12, h: 20, data: '{qr.profileUrl}' }
    ]
  },
  {
    id: 'royal-stripe',
    name: 'Royal Stripe',
    metadata: { description: 'High-contrast stripe with centered identity' },
    size: 'CR80',
    orientation: 'landscape',
    background: { color: '#101820', accentColor: '#FEE715', imageUrl: '' },
    elements: [
      { id: 'stripe', type: 'shape', x: 0, y: 40, w: 100, h: 24, color: '#FEE715' },
      { id: 'logo', type: 'logo', x: 86, y: 8, w: 10, h: 10, src: '{school.logoUrl}' },
      { id: 'photo', type: 'photo', x: 5, y: 16, w: 24, h: 68, radius: 4, imgBinding: 'student', src: '{student.photoUrl}' },
      { id: 'name', type: 'text', text: '{name}', x: 32, y: 22, w: 60, h: 12, fontSize: 8.5, fontWeight: 900, color: '#FFFFFF' },
      { id: 'role', type: 'text', text: '{role}', x: 32, y: 34, w: 60, h: 8, fontSize: 5.5, color: '#FFFFFF' },
      { id: 'id', type: 'text', text: 'ID: {studentNumber}', x: 32, y: 46, w: 60, h: 8, fontSize: 5, color: '#101820' },
      { id: 'class', type: 'text', text: 'Class: {className}', x: 32, y: 54, w: 60, h: 8, fontSize: 5, color: '#101820' },
      { id: 'contact', type: 'text', text: '{guardian.phone}', x: 32, y: 62, w: 60, h: 8, fontSize: 5, color: '#101820' },
      { id: 'expiry', type: 'text', text: 'Exp: {expiryDate}', x: 32, y: 70, w: 60, h: 8, fontSize: 5, color: '#101820' }
    ]
  },
  {
    id: 'minimal-white',
    name: 'Minimal White',
    metadata: { description: 'Minimalist with subtle grey and bold name' },
    size: 'CR80',
    orientation: 'landscape',
    background: { color: '#FFFFFF', accentColor: '#9E9E9E', imageUrl: '' },
    elements: [
      { id: 'photo', type: 'photo', x: 5, y: 15, w: 28, h: 70, radius: 6, imgBinding: 'student', src: '{student.photoUrl}' },
      { id: 'name', type: 'text', text: '{name}', x: 38, y: 28, w: 55, h: 12, fontSize: 8, fontWeight: 700, color: '#111111' },
      { id: 'role', type: 'text', text: '{role}', x: 38, y: 40, w: 55, h: 8, fontSize: 5.5, color: '#424242' },
      { id: 'id', type: 'text', text: 'ID: {studentNumber}', x: 38, y: 50, w: 55, h: 8, fontSize: 5, color: '#616161' },
      { id: 'class', type: 'text', text: 'Class: {className}', x: 38, y: 58, w: 55, h: 8, fontSize: 5, color: '#616161' },
      { id: 'barcode', type: 'barcode', x: 38, y: 70, w: 55, h: 18, data: '{studentNumber}' },
      { id: 'logo', type: 'logo', x: 83, y: 8, w: 12, h: 12, src: '{school.logoUrl}' }
    ]
  },
  {
    id: 'classic-border',
    name: 'Classic Border',
    metadata: { description: 'Classic framed card with a clean divider and strong hierarchy' },
    size: 'CR80',
    orientation: 'landscape',
    background: { color: '#FFFFFF', accentColor: '#1E3A8A', imageUrl: '' },
    elements: [
      { id: 'frame', type: 'shape', x: 1.5, y: 2.5, w: 97, h: 95, color: '#FFFFFF', borderColor: '#1E3A8A', borderWidth: 2, shapeType: 'rounded', radius: 10, opacity: 1 },
      { id: 'header', type: 'shape', x: 3, y: 4, w: 94, h: 18, color: '#1E3A8A', shapeType: 'rounded', radius: 8, opacity: 1 },
      { id: 'logo', type: 'logo', x: 6, y: 6.5, w: 12, h: 12, src: '{school.logoUrl}' },
      { id: 'schoolName', type: 'text', text: '{school.name}', x: 20, y: 7, w: 75, h: 10, fontSize: 7, fontWeight: 800, color: '#FFFFFF' },
      { id: 'divider', type: 'line', x: 36, y: 56, w: 58, h: 0, thicknessPx: 2, rotate: 0, color: '#CBD5E1' },
      { id: 'photo', type: 'photo', x: 6, y: 28, w: 26, h: 56, radius: 6, imgBinding: 'student', src: '{student.photoUrl}' },
      { id: 'name', type: 'text', text: '{name}', x: 36, y: 28, w: 58, h: 12, fontSize: 8.5, fontWeight: 900, color: '#111827' },
      { id: 'role', type: 'text', text: '{role}', x: 36, y: 40, w: 58, h: 8, fontSize: 5.5, color: '#334155' },
      { id: 'id', type: 'text', text: 'ID: {studentNumber}', x: 36, y: 48, w: 58, h: 8, fontSize: 5, color: '#475569' },
      { id: 'class', type: 'text', text: 'Class: {className}', x: 36, y: 56, w: 58, h: 8, fontSize: 5, color: '#475569' },
      { id: 'expiry', type: 'text', text: 'Expires: {expiryDate}', x: 36, y: 64, w: 58, h: 8, fontSize: 5, color: '#475569' }
    ]
  },
  {
    id: 'neo-glass',
    name: 'Neo Glass',
    metadata: { description: 'Modern glassmorphism panel with bold accent and QR' },
    size: 'CR80',
    orientation: 'landscape',
    background: { color: '#0B1220', accentColor: '#22C55E', imageUrl: '' },
    elements: [
      { id: 'accent', type: 'shape', x: -12, y: -18, w: 62, h: 62, color: '#22C55E', opacity: 0.35, shapeType: 'circle', lockAspect: true },
      { id: 'accent2', type: 'shape', x: 70, y: 64, w: 44, h: 44, color: '#38BDF8', opacity: 0.25, shapeType: 'circle', lockAspect: true },
      { id: 'glass', type: 'shape', x: 6, y: 10, w: 88, h: 80, color: '#FFFFFF', opacity: 0.10, borderColor: '#FFFFFF', borderWidth: 1, shapeType: 'rounded', radius: 14 },
      { id: 'logo', type: 'logo', x: 10, y: 14, w: 12, h: 12, src: '{school.logoUrl}' },
      { id: 'schoolName', type: 'text', text: '{school.name}', x: 24, y: 14, w: 56, h: 10, fontSize: 6.5, fontWeight: 800, color: '#E5E7EB' },
      { id: 'photo', type: 'photo', x: 10, y: 30, w: 22, h: 56, radius: 10, imgBinding: 'student', src: '{student.photoUrl}' },
      { id: 'name', type: 'text', text: '{name}', x: 36, y: 30, w: 54, h: 12, fontSize: 8.5, fontWeight: 900, color: '#F9FAFB' },
      { id: 'role', type: 'text', text: '{role}', x: 36, y: 42, w: 54, h: 8, fontSize: 5.5, color: '#D1D5DB' },
      { id: 'id', type: 'text', text: 'ID: {studentNumber}', x: 36, y: 52, w: 54, h: 8, fontSize: 5, color: '#E5E7EB' },
      { id: 'class', type: 'text', text: 'Class: {className}', x: 36, y: 60, w: 54, h: 8, fontSize: 5, color: '#E5E7EB' },
      { id: 'qr', type: 'qr', x: 84, y: 60, w: 10, h: 24, data: '{qr.profileUrl}' }
    ]
  },
  {
    id: 'modern-split',
    name: 'Modern Split',
    metadata: { description: 'Modern split layout with strong color block and barcode' },
    size: 'CR80',
    orientation: 'landscape',
    background: { color: '#F8FAFC', accentColor: '#0EA5E9', imageUrl: '' },
    elements: [
      { id: 'leftBlock', type: 'shape', x: 0, y: 0, w: 36, h: 100, color: '#0EA5E9', opacity: 1 },
      { id: 'leftShade', type: 'shape', x: 0, y: 64, w: 36, h: 36, color: '#0284C7', opacity: 1 },
      { id: 'logo', type: 'logo', x: 6, y: 8, w: 20, h: 16, src: '{school.logoUrl}' },
      { id: 'photo', type: 'photo', x: 8, y: 30, w: 20, h: 48, radius: 8, imgBinding: 'student', src: '{student.photoUrl}' },
      { id: 'name', type: 'text', text: '{name}', x: 40, y: 22, w: 56, h: 12, fontSize: 8.5, fontWeight: 900, color: '#0F172A' },
      { id: 'role', type: 'text', text: '{role}', x: 40, y: 34, w: 56, h: 8, fontSize: 5.5, color: '#334155' },
      { id: 'divider', type: 'line', x: 40, y: 46, w: 56, h: 0, thicknessPx: 2, rotate: 0, color: '#CBD5E1' },
      { id: 'id', type: 'text', text: 'ID: {studentNumber}', x: 40, y: 46.8, w: 56, h: 8, fontSize: 5, color: '#475569' },
      { id: 'class', type: 'text', text: 'Class: {className}', x: 40, y: 56, w: 56, h: 8, fontSize: 5, color: '#475569' },
      { id: 'expiry', type: 'text', text: 'Expires: {expiryDate}', x: 40, y: 64, w: 56, h: 8, fontSize: 5, color: '#475569' },
      { id: 'barcode', type: 'barcode', x: 40, y: 74, w: 54, h: 18, data: '{studentNumber}' }
    ]
  }
];



